/*
 * @Desc: 问卷调查记录 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-22 14:37:19
 */
import request from "@/utils/request";
const index = {
    // 列表
    list(query) {
        return request({
            url: "/surveyLog/list",
            method: "get",
            params: query
        });
    },
    // 详情
    detail(data) {
        return request({
            url: "/surveyLog/detail",
            method: "post",
            data
        });
    },
    // 选中小区下拉选
    communitySelect(query) {
        return request({
            url: "/surveyLog/communitySelect",
            method: "get",
            params: query
        });
    },
    // 统计-上面数字
    topCount(query) {
        return request({
            url: "/surveyLog/topCount",
            method: "get",
            params: query
        });
    },
    // 统计-下面题
    tiCount(query) {
        return request({
            url: "/surveyLog/tiCount",
            method: "get",
            params: query
        });
    },
    // 填空列表
    tianList(query) {
        return request({
            url: "/surveyLog/tianList",
            method: "get",
            params: query
        });
    },
    // 详情
    exportData(query) {
        return request({
            url: "/surveyLog/exportData",
            method: "post",
            params: query
        });
    },
};
export default index;
